import React from "react";
import { SectionHeading } from "./SectionHeading";
import { SpaServiceCard } from "./SpaServiceCard";

export const SpaServicesSection = ({ services }) => {
  return (
    <section className="py-10 container-x" data-testid="spa-services-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-end mb-16">
        <div className="lg:col-span-10">
          <SectionHeading
            eyebrow=""
            title="Aesthetics "
            italicWord=""
            kicker="The face beyond the smile, Minimally invasive aesthetic treatments - Botox and Juvederm fillers - performed with a dentist's precision understanding of facial anatomy."
          />
        </div>

      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/10">
        {services.map((service, index) => (
          <React.Fragment key={service.slug}>
            <SpaServiceCard service={service} index={index} />

            {index === 0 && services.length === 2 && (
              <div
                data-testid="spa-service-video"
                className="bg-cream reveal"
                style={{ transitionDelay: "60ms" }}
              >
                <div className="h-full min-h-[420px] overflow-hidden">
                  <video
                    className="w-full h-full object-cover scale-125"
                    src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/testimonials/8bdce0df-5e4c-4aa6-b458-fe1351b40c6d.mp4"
                    autoPlay
                    loop
                    muted
                    controls
                    playsInline
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};
